import React, { useState, useEffect } from "react";
import { ShoppingBag } from "lucide-react";
import baseUrl from "../../base_url";

const BestsellerProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initial product data with MongoDB IDs from URLs
  const initialProducts = [
    {
      id: 1,
      mongoId: "67f41cffc21fa74899f0af2d",
      name: "Laundary Basket",
      price: "Rs.899.00", // fallback price
      image: "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744051455/fdlgp1flaleon2svkuy2.jpg",
      url: "/productpage/67f41cffc21fa74899f0af2d",
      tag: "Bestseller",
    },
    {
      id: 2,
      mongoId: "67f417b3c21fa74899f0a5fb",
      name: "Laundary Basket",
      price: "Rs.899.00",
      image: "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744050087/aavjtdgkqaotilrhdzow.jpg",
      url: "/productpage/67f417b3c21fa74899f0a5fb",
      tag: "New",
    },
    {
      id: 3,
      mongoId: "67f4343721a917db64176c80",
      name: "Cute Jute Basket",
      price: "Rs.599.00",
      image: "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744057395/z6tfda25f86vx0xlxrzg.jpg",
      url: "/productpage/67f4343721a917db64176c80",
      tag: "Popular",
    },
    {
      id: 4,
      mongoId: "67f4139b3bf18f9e839183a8",
      name: "Jute Bowl",
      price: "Rs.699.00",
      image: "http://res.cloudinary.com/dvibnwi1t/image/upload/v1744056517/zg0qdtegtowohuavrk3k.jpg",
      url: "/productpage/67f4139b3bf18f9e839183a8",
      tag: "Limited",
    },
  ];

  // Fetch individual product data
  const fetchProductData = async (mongoId) => {
    try {
      const response = await fetch(`${baseUrl}api/products/data/item/${mongoId}`);
      if (response.ok) {
        const data = await response.json();
        return data;
      }
      return null;
    } catch (error) {
      console.error(`Error fetching product ${mongoId}:`, error);
      return null;
    }
  };

  // Load products with updated data
  useEffect(() => {
    const loadProducts = async () => {
      setProducts(initialProducts);
      setLoading(false);
      const updatedProducts = await Promise.all(
        initialProducts.map(async (product) => {
          const apiData = await fetchProductData(product.mongoId);
          if (apiData) {
            return {
              ...product,
              price: apiData.data.price || product.price,
              // Add any other fields from API
            };
          }
          return product; // Return original if API fails
        })
      );
      setProducts(updatedProducts);
    };

    loadProducts().catch((err) => {
      console.error("Error loading products:", err);
      setError("Failed to load some product data");
    });
  }, [baseUrl]);

  // Function to manually refresh product data
  const refreshProductData = async () => {
    setLoading(true);
    try {
      const updatedProducts = await Promise.all(
        products.map(async (product) => {
          const apiData = await fetchProductData(product.mongoId);
          console.log(apiData)
          return apiData ? { ...product, ...apiData } : product;
        })
      );
      setProducts(updatedProducts);
    } catch (err) {
      setError("Failed to refresh product data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section-padding bg-jute-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="heading-md mb-3">Our Bestsellers</h2>
          <p className="max-w-2xl mx-auto text-muted-foreground">
            Discover our most loved products, handcrafted with care and designed to last.
          </p>
          {error && (
            <p className="text-red-500 text-sm mt-2">{error}</p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product) => (
            <div key={product.id} className="group">
              <div className="relative rounded-lg overflow-hidden mb-4">
                <a href={product.url}>
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full aspect-square object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </a>
                {product.tag && (
                  <div className="absolute top-3 left-3 bg-terracotta-500 text-white text-xs font-medium py-1 px-2 rounded">
                    {product.tag}
                  </div>
                )}
                <button 
                  className="absolute bottom-3 right-3 bg-white text-jute-800 rounded-full p-2 shadow-md opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
                  aria-label={`Add ${product.name} to cart`}
                >
                  <ShoppingBag size={18} />
                </button>
              </div>
              <div>
                <a href={product.url} className="block mb-1 hover:text-jute-700 transition-colors">
                  <h3 className="font-medium">{product.name}</h3>
                </a>
                <p className="text-jute-800 font-medium">
                  {product.price}
                  {loading && (
                    <span className="ml-2 text-xs text-gray-400 animate-pulse">
                      updating...
                    </span>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a href="/store/products" className="btn-outline mr-4">
            View All Products
          </a>
        </div>
      </div>
    </section>
  );
};

export default BestsellerProducts;